import { render, staticRenderFns } from "./GuestNewsletter.vue?vue&type=template&id=38deceb7"
import script from "./GuestNewsletter.vue?vue&type=script&lang=js"
export * from "./GuestNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports